<template>
    <div class="card">
        <div class="card-header">
            <h5 class="mb-0">Export Addon Survey</h5>
        </div>
        <div class="card-body">
            <div class="mb-3">
                <label class="form-label">Main Survey</label>
                <select class="form-select" v-model="survey_id">
                    <option v-for="option in options" :key="option.value" :value="option.value">
                        {{ option.text }}
                    </option>
                </select>
            </div>
            <button v-show="survey_id" class="btn btn-primary" @click.prevent="export_excel">Download Excel</button>
        </div>
    </div>
</template>
<script>
export default {
    name : 'AddonSurveyExport',
    created() {
        this.surveys_get();
    },
    data() {
        return {
            survey_id: null,
            options: [],
        }
    },
    methods: {
        surveys_get() {
            this.$store.dispatch(
                'records_readlist',
                {
                    table_name: 'g_surveys',
                    filter: {
                        addon_survey: {
                            operator: '>',
                            value: 0,
                            realfield: true
                        },
                        user_id: {
                            operator: '>',
                            value: 0,
                            realfield: true,
                        }
                    }
                }
            )
            .then((resp) => {
                const options = resp.data.result.map((r) => {
                    return {
                        value: r.id,
                        text: `${r.survey_name} (${r.id})`,
                    }
                });
                this.options = options;
            })
        },
        export_excel() {
            this.$store.dispatch('gdq_addonsurvey_exportexcel', { survey_id: this.survey_id})
            .then((resp) => {
                var fileURL = window.URL.createObjectURL(new Blob([resp.data]));
                var fileLink = document.createElement("a");
                fileLink.href = fileURL;
                var filename = `AddonSurvey_${this.survey_id}`;
                fileLink.setAttribute("download", filename + ".xlsx");
                document.body.appendChild(fileLink);
                fileLink.click();
            });
        },
    }
}
</script>
<style scoped>
</style>
